<template>
  <span>
    <el-tooltip  class="item" effect="dark" :enterable="false" :content="$t('common.edit')" placement="top-start">
      <i class="el-icon-edit icon-action" @click="handleOpenDialog" />
    </el-tooltip>
    <el-dialog
      v-on:open="handleOpenDialog"
      :title="$t('admin.userGroups.selectGroupsTitle')"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      class="dialog-with-cols"
    >
        <el-row>
          <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item" v-if="shouldShowSeeInvoices">
            <el-checkbox v-show="false"
              v-model="seeInvoices"
            >{{ $t('admin.userGroups.invite.shouldSeeInvoice') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
              <el-transfer
                v-model="selectedAccount"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="Account number or name"
                :data="accountList"
                :titles="[$t('admin.userGroups.availableAccounts'), $t('admin.userGroups.selectedAccounts')]"
              />
          </el-col>
        </el-row>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button
          type="primary"
          :id="'form-save-button' + user.user_id"
          @click="handleSave"
          size="mini"
        >
          {{ $t('common.save') }}
        </el-button>
        <el-button
          :id="'form-refresh-button' + user.user_id"
          @click="handleClose"
          size="mini"
        >
          {{ $t('common.cancel') }}
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
// import { ref } from 'vue';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import { map } from 'lodash';

export default {
  name: 'SelectGroupDialog',
  data() {
    return {
      dialogVisible: false,
      form: {
        accountFrom: null,
        accountTo: null,
        accountFromName: null,
        accountToName: null
      },
      urlShipper: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      selectedAccount: [],
      temporalSelectedAccount: [],
      accountList: [],
      accountType: 1,
      searchText: '',
      accountSearch: '',
      seeInvoices: false,
    };
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    isShipper: {
      type: [Boolean, Object],
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters(['accounts']),
    userRoles() {
      if (!this.user) {
        return [];
      }
      if (this.user.app_metadata && this.user.app_metadata.authorization && this.user.app_metadata.authorization.roles) {
        return this.user.app_metadata.authorization.roles;
      }
      return this.user && this.user.user_metadata && this.user.user_metadata.roles;
    },
    shouldShowSeeInvoices() {
      return this.userRoles && this.userRoles.includes('Consignee');
    },
    alreadySeeInvoices() {
      return this.userRoles && this.userRoles.includes('Customer');
    },
  },
  watch: {
    dialogVisible(val) {
      // if (val) {
      //   if (!this.accounts.list.length) {
      //     this.search(true);
      //   } else {
      //     this.accountList = this.mapAccountList();
      //   }
      // }
      // if (val) {
      //   // Llamamos a search siempre para asegurar datos frescos
      //   // o si la lógica de 'accountType' puede cambiar entre filas
      //   this.search(true);
      // }
      if (val) {
        // Obtenemos el tipo actual que necesitamos
        const currentType = this.isShipper ? 1 : 2;
        // Comparamos contra el tipo que el STORE dice que tiene cargado
        if (!this.accounts.list.length || this.accounts.lastTypeLoaded !== currentType) {
          this.search(true);
        } else {
          // Si es el mismo tipo, solo mapeamos lo que ya hay
          this.accountList = this.mapAccountList();
        }
      }
    },
    'accounts.list': function accountListChanged() {
      this.accountList = this.mapAccountList();
      this.setSelectedAccount();
    },
    user() {
      this.setSelectedAccount();
    }
  },
  methods: {
    async search(resetSearch) {
      const config = constants.LOADING.USERS_GROUPS;
      config.customClass = 'loading-group';
      const loading = this.$loading(config);
      this.busy = true;
      this.accountType = this.isShipper ? 1 : 2;
      // If sarch text is changed or reset search is mandatory we call to resetShipperList
      if ((this.searchText !== this.accountSearch) || resetSearch) {
        await this.$store.dispatch('account/resetList', this.accountType);
      }
      // eslint-disable-next-line no-plusplus
      this.accounts.filters.rows = 1000;
      do {
        await this.$store.dispatch('account/getListScroll', { search: this.searchText, accountType: this.accountType, includeWarehouseData: false });
      } while (this.accounts.list.length < this.accounts.totalRows);
      this.busy = false;
      this.setSelectedAccount();
      loading.close();
    },
    mapAccountList() {
      const mappedList = map(this.accounts.list, account => ({
        key: account.number,
        label: `${account.name} - ${account.number}`,
        description: account.name
      }));

      if (this.user.user_metadata && this.user.user_metadata.groups) {
        this.user.user_metadata.groups.forEach((group) => {
          if (!mappedList.some(item => item.key === group.name)) {
            mappedList.push({ key: group.name, label: `${group.description} - ${group.name}`, description: group.description });
          }
        });
      }
      return mappedList;
    },
    handleOpenDialog() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      if (this.reload) {
        this.search({});
      }
      if (done && done instanceof Function) {
        done();
      }
      this.dialogVisible = false;
    },
    handleSave() {
      const userMetadata = this.user.user_metadata;
      userMetadata.groups = this.getSelectedAccount();
      userMetadata.seeInvoices = this.seeInvoices;
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('userGroups/update', { userId: this.user.user_id, userMetadata })
        .then(() => {
          this.$message.success(this.$t('admin.userGroups.updateSuccess'));
          this.dialogVisible = false;
        })
        .finally(() => {
          loading.close();
        });
    },
    filterMethod(query, item) {
      return item.label && item.label.toLowerCase().includes(query.toLowerCase());
    },
    setSelectedAccount() {
      // eslint-disable-next-line prefer-destructuring
      const length = this.selectedAccount.length;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < length; i++) {
        this.selectedAccount.pop();
      }
      if (this.user.user_metadata && this.user.user_metadata.groups) {
        this.user.user_metadata.groups.forEach((group) => {
          this.selectedAccount.push(group.name);
        });
      }
    },
    getSelectedAccount() {
      if (this.selectedAccount.length) {
        return this.accountList
          .filter((account) => this.selectedAccount.includes(account.key))
          .map((account) => ({ name: account.key, description: account.description }));
      }
      return [];
    }
  },
  mounted() {
    this.setSelectedAccount();
    if (this.user.user_metadata && this.user.user_metadata.groups) {
      this.selectedAccount.slice(0, this.selectedAccount.length);
      this.user.user_metadata.groups.forEach((group) => {
        this.temporalSelectedAccount.push(group.name);
      });
      this.seeInvoices = this.userRoles.includes('Customer');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.loading-group {
  z-index: 9999 !important;
}
.el-checkbox {
  margin-left: 1em;
  margin-bottom: 0.5em;
}
</style>
